export const MAX_REMOTE_VIDEOS_ON = 6
export const GOOD_NETWORK_MIN_THRESHOLD_VALUE = 2
export const TTM_DATA_SEND_INTERVAL = 5000
export const LOCAL_SPEAKER_THRESHOLD = 12
